<script setup>
import { onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useFunctionGetter, useStore } from 'dashboard/composables/store';

import WootReports from './components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();
const store = useStore();
const label = useFunctionGetter('labels/getLabelById', route.params.id);

const reportTitle = computed(
  () => label.value?.title || label.value?.name || t('LABEL_REPORTS.HEADER')
);

onMounted(() => store.dispatch('labels/get'));
</script>

<template>
  <WootReports
    v-if="label.id"
    :key="label.id"
    type="label"
    getter-key="labels/getLabels"
    action-key="labels/get"
    header-icon="i-lucide-tag"
    header-accent="amber"
    back-route="label_reports_index"
    :selected-item="label"
    :download-button-label="$t('LABEL_REPORTS.DOWNLOAD_LABEL_REPORTS')"
    :report-title="reportTitle"
    :report-subtitle="$t('LABEL_REPORTS.DESCRIPTION')"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
